// Conversation.Ref — version-level reference to a Conversation.
export { mk };
const mk = (id, version) => ({
    type: "conversation_ref",
    id,
    version,
});
//# sourceMappingURL=ref.js.map